import { Team, TeamService } from '../../team';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import {TeamUserService} from '@app/_components/team/team-user/team-user.service';
import {TeamUser} from '@app/_components/team/team-user/team-user';

@Component({
    selector: 'app-team',
    templateUrl: './team.component.html',
    styleUrls: ['./team.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class TeamComponent implements OnInit {

	visibilities: any;
	teamtypes: any;
	constructor(
		private primengConfig: PrimeNGConfig,
		private teamService: TeamService,
		private teamUserService: TeamUserService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.team = data.team,
			this.visibilities = teamService.visibilities;
			this.teamtypes = teamService.teamtypes;
	}

	@Input() team: Team;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doUpdateAndDontClonse = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	teamId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;
	userColumns: any[] = [
		{ field: 'userId', header: 'userId', width: 'auto' },
		{ field: 'firstName', header: 'firstName', width: 'auto' },
		{ field: 'lastName', header: 'lastName', width: 'auto' },
		{ field: 'emailAddress', header: 'emailAddress', width: 'auto' },
	];

	validationMessages = {
		'teamId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'visibility': [],
		'teamType': []
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole team object
		if (this.team) {
			this.teamId = this.team.teamId;
			this.form1.patchValue(this.team);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.teamId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete();
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.teamService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.team = res.data.team;
						this.doAdd.emit(this.team);
					},
					(err: any) => {
						console.log('team-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('team: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.teamService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.team = res.data.team;
						this.doUpdate.emit(this.team);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.teamService.delete(this.team.teamId)
				.subscribe(
					(res: any) => {
						console.log('team-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.team);
					},
					(err: any) => {
						console.log('team-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			teamId: [this.teamId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: [],
			teamType: [],
			visibility: [],
		});
	}

	onUserAdded(user: any) {
    let teamUser = new TeamUser();
    teamUser.userId = user.userId;
    teamUser.teamId = this.team.teamId;
    this.teamUserService.add(teamUser).subscribe(
      (res: any) => {
        console.log('team member added SUCCESS: ' + JSON.stringify(res));
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
        this.reloadData();
      },
      (err: any) => {
        console.log('activityProvider-add FAIL: ' + JSON.stringify(err));
        this.alertService.error(err);
      },
      () => { this.formLoading = false; });
	}

  removeUserFromTeam( teamUser: TeamUser) {
    teamUser.teamId = this.team.teamId;
    this.teamUserService.delete(teamUser).subscribe(
      (res: any) => {
        console.log('activityProvider-delete SUCCESS: ' + JSON.stringify(res));
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
        this.reloadData();
      },
      (err: any) => {
        console.log('activityProvider-add FAIL: ' + JSON.stringify(err));
        this.alertService.error(err);
      },
      () => { this.formLoading = false; });
	}
  reloadData(){
    this.teamService.findById(this.team.teamId).subscribe(
      res => {
        console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
        this.team = res.data.team;
        this.form1.patchValue(this.team);
        this.doUpdateAndDontClonse.emit(this.team);
      },
      err => {
        console.log('Feature-Update FAIL: ' + JSON.stringify(err));
        this.alertService.error(err);
      },
      () => { });
  }
}
